import { ColDef } from 'ag-grid-community';
import { useValueWithUnitFormatter, type ValueWithUnit } from 'components/shared/ValueWithUnit/FormattedValueWithUnit';
import { useMemo } from 'react';

export function useValueWithUnitColumnType() {
  const formatter = useValueWithUnitFormatter();
  return useMemo(
    () =>
      ({
        filter: 'agNumberColumnFilter',
        cellClass: 'ag-right-aligned-cell',
        valueGetter: ({ data, colDef: { field } }) => {
          if (field === undefined) {
            return undefined;
          }
          const options = data[field] as ValueWithUnit | undefined | null;
          return formatter(options);
        },
        filterValueGetter: ({ data, colDef: { field } }) => {
          if (field === undefined) {
            return undefined;
          }
          const options = data[field] as ValueWithUnit | undefined | null;
          return options?.value;
        },
      }) satisfies ColDef,
    [formatter],
  );
}
